import React, { useEffect, useState } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { Button, message, Table, Upload } from 'antd';
import { useUploadPincode } from './store';
import Papa from "papaparse";


const PincodeManagement = () => {
    const { uploadPrepaidPincodesFile, uploadServiceablePincodesFile, fetchServiceablePincode, fetchPrepaidPincode, prepaidPincodeData, serciveablePincodeData, fetchBlockedCustomersData, uploadblockedCustomers, blockedCustomersData } = useUploadPincode();
    useEffect(() => {
        fetchServiceablePincode();
        fetchPrepaidPincode();
        fetchBlockedCustomersData();
    }, [])
    const [prepaidFileList, setPrepaidtFileList] = useState([]);
    const [serviceableFileList, setServiceableFileList] = useState([]);
    const [blockedCustomerFilelist, setBlockedCustomerFilelist] = useState([]);
    const [serviceableUploading, setServiceableUploading] = useState(false);
    const [prepaidUploading, setPrepaidUploading] = useState(false);
    const [blockedCustomerUploading, setBlockedCustomerUploading] = useState(false);

    const downloadCSV = async (data, csvName) => {
        const opts = {
            delimiter: ",",
            header: true,
            newline: "\n",
        };
        const csvString = Papa.unparse(data, opts);
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8" });
        saveAs(blob, csvName);
    };

    const csvDataAndHeader = {
        prepaid: { data: prepaidPincodeData, header: 'Prepaid Pincodes', filename: 'prepaid-pincodes' },
        serviceable: { data: serciveablePincodeData, header: 'Serviceable Pincodes', filename: 'serviceable-pincodes' },
        blockedCx: { data: blockedCustomersData, header: 'Blocked Customers', filename: 'blocked-customers' }
    }
    
    const createCSV = async (type) => {
        const { data, header, filename } = csvDataAndHeader[type]
        const _fileName = `${filename}.csv`;

        if (Array.isArray(data)) {
            const codes = data?.reduce((acc, curr) => {
                if (curr) acc.push({ [header]: curr });
                return acc;
            }, []);
            await downloadCSV(codes, _fileName);
        }
    };
    const dataSource = [
        {
            key: 'prepaid-pincode',
            updaloadName: 'Upload Prepaid Pincodes',
            select: <UploadFile fileList={prepaidFileList} setFileList={setPrepaidtFileList} />,
            submit: <SubmitUpload fileList={prepaidFileList} setFileList={setPrepaidtFileList} uploadFunction={uploadPrepaidPincodesFile} upLoading={prepaidUploading} setUpLoading={setPrepaidUploading} />,
            download: <Button
                type="primary"
                onClick={() => { createCSV('prepaid') }}
            >
                Download
            </Button>,
        },
        {
            key: 'serviceable-pincode',
            updaloadName: 'Upload Serviceable Pincodes',
            select: <UploadFile fileList={serviceableFileList} setFileList={setServiceableFileList} />,
            submit: <SubmitUpload fileList={serviceableFileList} setFileList={setServiceableFileList} uploadFunction={uploadServiceablePincodesFile} upLoading={serviceableUploading} setUpLoading={setServiceableUploading} />,
            download: <Button
                type="primary"
                onClick={() => { createCSV('serviceable') }}
            >
                Download
            </Button>,
        },
        {
            key: 'blocked-customers',
            updaloadName: 'Upload Blocked Customers',
            select: <UploadFile fileList={blockedCustomerFilelist} setFileList={setBlockedCustomerFilelist} />,
            submit: <SubmitUpload fileList={blockedCustomerFilelist} setFileList={setBlockedCustomerFilelist} uploadFunction={uploadblockedCustomers} upLoading={blockedCustomerUploading} setUpLoading={setBlockedCustomerUploading} />,
            download: <Button
                type="primary"
                onClick={() => { createCSV('blockedCx') }}
            >
                Download
            </Button>,
        }
    ];

    const columns = [
        {
            title: 'Upload',
            dataIndex: 'updaloadName',
            key: 'pincode',
        },
        {
            title: 'Select',
            dataIndex: 'select',
            key: 'select',
        },
        {
            title: 'Submit',
            dataIndex: 'submit',
            key: 'submit',
        },
        {
            title: 'Download',
            dataIndex: 'download',
            key: 'download',
        },
    ];


    return (
        <Table dataSource={dataSource} columns={columns} />
    );
}

export default PincodeManagement

const UploadFile = ({ fileList, setFileList, }) => {
    const uploadProps = {
        accept: '.csv',
        onRemove: (file) => {
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            setFileList(newFileList);
        },
        beforeUpload: (file) => {
            if (file.type !== "text/csv" && file.type !== "application/vnd.ms-excel") {
                message.error(`only csv file allowed`);
                return true;
            }
            setFileList([...fileList, file]);
            return false;
        },
        fileList,
    }
    return (
        <Upload {...uploadProps}>
            <Button icon={<UploadOutlined />}>Select File</Button>
        </Upload>
    )
}

const SubmitUpload = ({ fileList,setFileList, uploadFunction, upLoading, setUpLoading }) => {
    const handleUpload = () => {
        const fileData = new FormData();
        fileList.forEach((file) => {
            fileData.append('file', file);
        });
        setUpLoading(true);
        uploadFunction(fileData,
            setFileList,
            message,
            setUpLoading);
    }
    return (
        <Button
            type="primary"
            onClick={handleUpload}
            disabled={fileList.length === 0}
            loading={upLoading}

        >
            {upLoading ? 'Uploading' : 'Start Upload'}
        </Button>
    )
}